import type { DeviceInfoService } from "./../../shared/core/device-info-service";

export class WebDeviceInfoService implements DeviceInfoService {
  public getModel(): string {
    return "WEB";
  }
}
